export default __webpack_public_path__ + "static/media/paper.1fc4784b.svg";